import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerService from '../../services/SpinnerService';
//styles
import styles from './DynamicTabSystem.module.scss';
import { dashboardTabWorkflowId } from '../../services/SizingToolService';

export default function DynaTab(props: {
  id: string;
  tabTitle: string;
  isActive: boolean;
  handleClick: (id: string) => void;
  handleClose: (id: string) => void;
}) {
  return (
    <div
      onClick={() => props.handleClick(props.id)}
      className={props.isActive ? styles['dynamic-tab-active'] : styles['dynamic-tab']}
    >
      <div className={styles['tab-title-div']}>{props.tabTitle}</div>
      <button
        hidden={props.id === dashboardTabWorkflowId}
        className={styles['unstyled-button']}
        onClick={(e) => {
          e.stopPropagation();
          props.handleClose(props.id);
          SpinnerService.updateSpinnerStatus(0, true);
        }}
      >
        <FontAwesomeIcon icon={'xmark'} />
      </button>
    </div>
  );
}
